import { ActivatedRoute } from '@angular/router';
import { HostListener, Component, OnInit, OnDestroy, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { NgbModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import { environment } from '../../environments/environment';
import { AppConfig } from '../../app/config/app.config';
import { ButtonBarComponent } from '../guicomponents/buttonbar/buttonbar.component';
import { ConfirmComponent } from '../dialogboxes/confirm.component';
import { ErrorHandlerService } from '../../app/errorhandler/gpiserror-handler.service';
import { ErrorObject } from '../../app/errorhandler/gpiserror-object';
import { SequenceInstructionItem, SequenceInstructionPart, PkgInstrLevelInfo, PkgInstrLevelMaterialBE, PkgInstrLevelAdditionalMaterialBE, ApprovalBE, SupplierPruTypeBE, PkgInstrPruRelationBE } from '../sequence-instruction/shared/sequence-instruction.model';
import { PictureBe } from '../image-library/shared/image-model';
import { ImageCommon } from '../image-library/image-common';
import { IReturnObject } from '../shared/return-object.model';
import { ErrorTypeEnum, ConflictTypeEnum } from '../shared/enums.model';
import { SequenceInstructionService } from '../sequence-instruction/sequence-instruction.service';
import { ConfirmResult } from '../../app/dialogboxes/shared/confirm.model'
import { PartSupplierPruBe, PartListBE } from '../partsupplierpru/shared/partsupplierpru.model';
import { PartSupplierPruService } from '../partsupplierpru/partsupplierpru.service';
import { PArray } from '../shared/packit-array';
import { AttributeListBE } from '../shared/attribute-list.model';
import { UserHandling } from '../shared/user-handling';
import { ComponentCanDeactivate } from '../../app/shared/page.pendingchangesguard';
import { PackagingInstructionSelectListComponent } from '../packaging-instruction/packaging-instruction-selectlist.component';
import { StatusEnum } from '../shared/enums.model';
import { NgbDateFRParserFormatter } from '../shared/ngb-date-fr-parser-formatter';
import { SupplierService } from '../../app/supplier/supplier.service';
import { DashBoardService } from '../../app/dashboard/dashboard.service';
import { PiHistoryListBE } from '../../app/dashboard/shared/dashboard.model';
import { MultiPartService } from '../../app/multipart-part/multipart-part.service';
import { ListPackagingInstructionMaterialComponent } from '../packaging-instruction/list-packaging-instruction-material.component';
import { SupplierMassMailService } from '../supplier-mass-mail/supplier-mass-mail.service';
import { PartSearchComponent } from '../../app/part-search/part-search.component';
import { forEach } from '@angular/router/src/utils/collection';
import { EILSEQ } from 'constants';
import { PackagingMaterialAttirbuteService } from '../packaging-material-attributes/packaging-material-attributes.service';
import { SupplierListBE } from '../supplier/shared/supplier.model';
import { SupplierContactService } from '../supplier-contact/supplier-contacts.service';
import { SupplierInfoBE ,SupplierEmailBE} from '../sequence-instruction/shared/sequence-instruction.model';
import { MailingListBE } from '../supplier-mass-mail/shared/supplier-mass-mail.model';
import { SetFocus } from '../../app/shared/setFocus';
import { Message } from '@angular/compiler/src/i18n/i18n_ast';
import { first } from 'rxjs/operator/first';
import { element } from 'protractor';
import { map } from 'rxjs/operator/map';
import { async } from '@angular/core/testing';
import { ChangeIssuerService } from '../../app/change-issuer/change-issuer.service';
import { AnimationTransitionInstructionType } from '@angular/animations/browser/src/render/animation_engine_instruction';

declare var jQuery: any;

// Same as database id from table status
const MIN_NAME_LENGTH = 7;
let disable:boolean;
let PnL = 0;
let CW2 = 0;
let siname = '';
let flagPnL = '';
let sendToSupplierVerified = false;
//needed for naming logic
let firstpart='';
export class ConflictList{
  //pru and suppliers can be added if required
  PkgInstrId: number;
  PartNo:string[];
  PIName:string;
   public constructor(pkgInstId: number){
      this.PkgInstrId=pkgInstId;
  }
}

@Component({
  selector: 'sequence-instruction',
  templateUrl: './sequence-instruction.component.html',
  providers: [MultiPartService, ChangeIssuerService, SequenceInstructionService, PartSupplierPruService, SupplierService, DashBoardService, PackagingMaterialAttirbuteService, SupplierContactService, SupplierService, SupplierMassMailService],
  styleUrls: ['./sequence-instruction.component.css']
})
export class SequenceInstructionComponent implements OnInit, OnDestroy, ComponentCanDeactivate {

  @Input() instructionIdFromParentCtrl: number;

  selectedInstructionId: number = -1;
  user: UserHandling = new UserHandling();
  instruction: SequenceInstructionItem = undefined;
  viewSupplierListSpinner;

  // Search PI
  fetchDataFunction: any = (searchTerm: string) => { this.loadInstructionList(searchTerm); };
  instructionsList: AttributeListBE[];
  supplierContactList:SupplierEmailBE[];
  typeOfWeight: number;// Added on 20 August,21

  // Confirm dialog box
  @ViewChild('cDlg') cdlg: ElementRef;
  dialogAction: string;
  dialogBtnType: string;
  dialogAppliesTo: string = "";
  dialogAppliesToId: number = -1;
  confirmDlgText: string = "";
  startDate: NgbDateStruct;
  createDate: NgbDateStruct;
  dateFormatter: NgbDateFRParserFormatter = new NgbDateFRParserFormatter();
  dateConfig: NgbDatepickerConfig = new NgbDatepickerConfig();

  // Panel header text toggle for parts, prus and suppliers info
  supplierListVisible: boolean = false;
  partListVisible: boolean = false;
  pruListVisible: boolean = false;

  // Image
  image1: any;
  imageLibraryEvent: PictureBe;//Testing variable
  pictureLabels: string = "";
  imageSearchResult: PictureBe[] = [];
  selectedImages: Array<number> = [];
  pictureIdS: Array<number> = [];
  deleteImageInfo: PictureBe;
  @Output() piImageId: Array<number> = [];
  PITitle: string = "";

  // Button bar
  btnDuplicateVisible: boolean = true;
  btnNewVisible: boolean = true;
  btnPreviewVisible: boolean = true;
  btnSaveVisible: boolean = true;
  btnApproveVisible: boolean = true;
  btnHistoryVisible: boolean = true;
  btnDeleteVisible: boolean = true;

  // Misc
  showSpinner: boolean = false;
  typeDelayTimer: any = null;
  currentDlg: NgbModalRef;
  isDirty: boolean = false;
  newInstructionText: string = null;
  unreliablePartText: string = "";

   //flag
   isDuplicate:boolean=false

  // input action timer;
  pendingAction: any = null;
  historyList: PiHistoryListBE[] = []; 1

  //history list
  @ViewChild('viewHistoryDlg') historyDlg: ElementRef;
  showHistorySpinner: boolean = true;

  // Weight and deviation
  partWeight: number = 0;
  totalPartWeight: number = 0;
  grossWeight: number = 0;
  totalPackaginWeight: number = 0;


  // is pi unique
  orgName: string = "";
  nameExistsClass: string = "";
  duplicatesiname: string = "";

  // send for approval
  approvalMessage: string = "";
  sendForApprovalSuppliers: PartSupplierPruBe[] = [];
  sendToSupplierOrAccept: string = "";

  @ViewChild('sendPIForAproval') approvaDlg: ElementRef;

  // Other info
  otherInfos: Array<string> = [];
  newOtherInfo: string = '';

  // Pru-supplier
  partSuppPru: PartSupplierPruBe[] = [];
  SupplierEmail: SupplierEmailBE[]=[];
  SupplierandContact:SupplierEmailBE[]=[];
  selectedPartRelationId: number = null;
  consistingParts: PartListBE[] = [];
  pruList: AttributeListBE[] = [];
  prunames:string[]=[];

    // supplier search
    searchSupplierText: string = "";
    viewSupplierList: boolean = false;
    searchKeyStrokeDelay: number = 350;
    supplierSearchListDelayTimer: any = null;
    searchListDelayTimerDelay: number = 250;
    supplierList: SupplierListBE[];

    mailingList: MailingListBE[] = [];
    selectedSupplierName: string = "";
    isFocusSet: boolean = false;
    setFocus: SetFocus = new SetFocus();
    showMailingListSpinner: boolean = false;

  // Levels
  editLevelData: PkgInstrLevelInfo = null;
  constraintCodeId: number = null;
  hasSubLevelCode: boolean = false;
  Mhnumber: Array<string> = [];
  public Exclusionlist: Array<string> = [];

  //Conflict dialog
  @ViewChild('conflictPruDlg') conflictPruDlg: ElementRef;
  conflictResponseObj: Array<PkgInstrPruRelationBE>;
  conflictList:Array<ConflictList>;
  activeConflictItemId: number;
  public conflictEnums = ConflictTypeEnum;
  currentConflictDlg: NgbModalRef;
  uniqueIds:number[]=[];

  showUnitLoadingAnimation: boolean = false;
  showSupplierRelLoadingAnim: boolean = false;

  levelIndexes: number[] = [0, 1, 2, 3];
  instructionSupplierList: any;
  isEdited: boolean;
  isApproved: boolean;

  constructor(private seqInstrService: SequenceInstructionService,
    private partSupplierPruService: PartSupplierPruService,
    private modalService: NgbModal,
    private _route: ActivatedRoute,
    private config: AppConfig,
    private supplierService: SupplierService,
    private errHandler: ErrorHandlerService,
    private dashBoardService: DashBoardService,
    private multiPartService: MultiPartService,
    private materialAttrService: PackagingMaterialAttirbuteService,
    private supplierMassMailService: SupplierMassMailService,
    private supplierContactService: SupplierContactService,
    private dater: NgbDateParserFormatter,
    private changeIssuerService: ChangeIssuerService) {

      this.isEdited = sessionStorage.getItem('isUser') == 'true' ? true : false
      this.isApproved = sessionStorage.getItem('isApprover') == 'true' ? true : false

  }

  @HostListener('window:beforeunload')
  canDeactivate(): Observable<boolean> | boolean {
    return !this.isDirty;
  }


  // ----------------------------------------------------------
  // Life cycle hooks
  // ----------------------------------------------------------
  ngOnInit(): void {
    // First check if we get here from a route containing the id
    // If its not from a route, check if the page is used as a control that passes an id
    // If its neither then abort loading
    this.getMaterialExclusions();
    this.errHandler.emitErrorObject(null);
    var id = +this._route.snapshot.params["seqInstructionId"];
    if (isNaN(id) || id < 1) {
      if (!isNaN(this.instructionIdFromParentCtrl) || id > 0)
        id = this.instructionIdFromParentCtrl;
      else {
        this.instructionIdFromParentCtrl = null;
        this.showSpinner = false;
        return;
      }
    }
    this.selectedInstructionId = id;
    this.loadInstruction();
  }

  ngOnDestroy() {
    sessionStorage.removeItem('isUser');
    sessionStorage.removeItem('isApprover');
   }

  // ----------------------------------------------------------
  // Service calls and support methods
  // ----------------------------------------------------------
   
  saveInstruction() {
   
    //console.log(this.instruction.Description);
    //debugger;
    this.showSpinner = true;
    this.setWeights();
    this.setInstructionStartEndDate();
    this.instruction.Weight = this.totalPackaginWeight;
    this.instruction.Comment=this.instruction.Comment;
    this.instruction.Description=this.instruction.Description;
    this.instruction.GrossWeight = this.grossWeight;



    this.instruction.TotalPartWeight=this.instruction.TotalPartWeight;

    this.isContentValid()
    this.setSIName(); //set SI Name
    
    let tempInstr: SequenceInstructionItem = this.preparePkgInstrToPost();
   // this.approveInstruction();

    this.seqInstrService.saveInstruction(tempInstr)
        .subscribe(returnObject => this.saveInstructionResponse(returnObject));

    //this.clearPruListSelections();
  }

  saveInstructionResponse(returnObject: IReturnObject) {
    if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
      this.errHandler.emitError(returnObject.ErrorMsg, 'PackagingInstructionComponent.saveResponse', returnObject.ErrorType);
    }
    else {
      this.info("The instruction was saved successsfully");
      this.setLoadedValues(returnObject);
      this.isDirty = false;
    }
    this.showSpinner = false;
    this.newInstructionText = null;
  }

  preparePkgInstrToPost(): SequenceInstructionItem {
    // Cant delete the picture in instruction because it will then disappear from screen.
    // Alas, we save the instruction in a temp var and remove the bit stream in PictureImage
    // before sending to server.
    let tempInstr: SequenceInstructionItem = JSON.parse(JSON.stringify(this.instruction));
    for (var i = 0; i < tempInstr.Pictures.length; i++)
      tempInstr.Pictures[i].PictureImage = null;

    return tempInstr;
  }

  setSIName(){
    //debugger;
    var pruname="";
    firstpart=this.instruction.Parts[0].Description;
    if (this.pruList != null) {
      //get the name of all pru units
      this.pruList.forEach(item => {
        if (item.Selected === true) {
          pruname = pruname + item.Description + ", ";
        }
      });

    if (flagPnL != "") {
      if (!pruname.includes(flagPnL))
      pruname = pruname + ", " + flagPnL;
    }
    flagPnL = "";
    if (pruname.endsWith(", ")) {
      pruname = pruname.slice(0, -2);  //to remove extra spaces
      }
      pruname = pruname.replace(", ,", ",");
    if(this.instruction.Id==-1 && this.isDuplicate==false)
    {
          //New Instruction
          this.instruction.SIName=firstpart+"-"+pruname;
    }
    else
    {  //the instruction already exists or is duplicate
      var Name=this.instruction.SIName.split('_');
      var parentName=Name[0]+ '_' +Name[1];
      this.instruction.SIName=parentName+ '_' +firstpart+"-"+pruname;
      if(this.isDuplicate)
      {
        this.instruction.SIName=this.instruction.SIName+"duplicate";
      }
    }
      this.isDuplicate=false;
    }

  }
  setDuplicateSIName(){
    //set next name as current as the logic is already fetched from backend
    //debugger;
    siname='';
    if (this.pruList != null) {
      this.pruList.forEach(item => {
        if (item.Selected == true) {
          siname = siname + item.Description + ", ";
        }
      });
    }
    if (flagPnL != "") {
      if (!siname.includes(flagPnL))
      siname = siname + ", " + flagPnL;
    }
    flagPnL = "";
    this.instruction.SIName=this.instruction.nextSIname+"duplicate";

    let SIName=this.instruction.SIName;
  }


  deleteInstruction() {
    let deleteMessage = "Deleted reason"
    this.currentDlg.close();
    this.showSpinner = true;
    this.errHandler.emitErrorObject(null);
    this.seqInstrService.deleteInstruction(this.instruction.Id, deleteMessage, this.user.UserId)
      .subscribe(returnObject => this.deleteInstructionResponse(returnObject));
  }

  deleteInstructionResponse(returnObject: IReturnObject) {
    if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
      this.errHandler.emitError(returnObject.ErrorMsg, 'PackagingInstructionComponent.deleteInstructionResponse', returnObject.ErrorType);
    }
    else {
      if (returnObject.DataList[0].Id == -1) {
        this.info("The material was deleted");
        this.selectedInstructionId = null;
        this.setNewInstructionData();
      }
      else {
        this.info("The sequence instruction was scrapped");
        this.setLoadedValues(returnObject);
      }
    }
    this.showSpinner = false;
  }

  deletePart(partId: number): void {
    this.unreliablePartText = "";
    this.errHandler.emitErrorObject(null);
    this.currentDlg.close();
    let pArr: PArray<SequenceInstructionPart> = new PArray(this.instruction.Parts);

    //Here partId is actually the index position of the selected Part ID
    pArr.removAtIndex(partId);

    this.instruction.PartRelations = [];
    this.partSuppPru = [];
    this.setDirty();
    this.setQuantityInLevel();

    //this.clearPruListSelections();
  }


  deleteSupplier(supplierID:number):void{

    //Here supplierID is actually the index position of the selected Supplier ID
    this.unreliablePartText = "";
    this.errHandler.emitErrorObject(null);
    this.currentDlg.close();
    let sArr:PArray<SupplierInfoBE>=new PArray(this.instruction.SupplierInfo);
    sArr.removAtIndex(supplierID);

    this.instruction.PartRelations = [];
    this.partSuppPru = [];
    this.setDirty();
    this.setQuantityInLevel();

    //this.clearPruListSelections();
  }

  checkSupplierContactsExist() {
    this.showSpinner = true;
    let suppNos: string[] = [];
    //this.prepareApprovalDlg(); // suppliers list to send email

    if (this.instruction.SupplierInfo.length != null) {
      for (var i = 0; i < this.instruction.SupplierInfo.length; i++) {

         //suppNos.push(this.sendForApprovalSuppliers[i].SupplierNo);
         let supNo:string=String(this.instruction.SupplierInfo[i].SupplierId)

         suppNos.push(supNo); // supplier string for backend
      }
      this.sendToSupplierOrAccept = "send";
    }

    if (suppNos.length == 0) { // why activate code is written here ?
      this.sendToSupplierOrAccept = "activate";
      this.currentDlg = this.modalService.open(this.approvaDlg, {
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      });
      this.showSpinner = false;
    }
    else {
      this.seqInstrService.existsContactsForSendForApproval(suppNos.join(","))
        .subscribe(returnObject => this.checkSupplierContactsExistResponse(returnObject));
    }

  }

  checkSupplierContactsExistResponse(returnObject: IReturnObject) {
    if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
      this.errHandler.emitError(returnObject.ErrorMsg, 'SequenceInstructionComponent.checkSupplierContactsExistResponse', returnObject.ErrorType);
    } else {
      this.sendToSupplierOrAccept = "send";
      this.currentDlg = this.modalService.open(this.approvaDlg, {
        size: 'sm',
        backdrop: 'static',
        keyboard: false

      });
      this.supplierContactList = <SupplierEmailBE[]>returnObject.DataList;
    }
    this.showSpinner = false;
  }


  approveInstruction() {

    this.showSpinner = true;
    this.errHandler.emitErrorObject(null);

    let approvalBE: ApprovalBE = new ApprovalBE();
    approvalBE.ActivateNow = this.instruction.StatusId == StatusEnum.Active ? true : false;
    approvalBE.Part = this.instruction.SIName;
    approvalBE.InstructionId = this.instruction.Id;
    approvalBE.Message = this.approvalMessage;
    approvalBE.UserId = this.user.UserId;
    approvalBE.StartDate = this.instruction.StringStartDate;
    approvalBE.InstructionType=2;


    for(let i=0;i<this.instruction.SupplierInfo.length;i++){

    }

    if(this.instruction.SupplierInfo!=null){

      this.instruction.SupplierInfo.forEach(x=>{
      approvalBE.SupplierPruTypeList.push(new SupplierPruTypeBE(x.SupplierId.toString(),0));//passing pruid as 0 since it is not mapped to supplier in sequence
      })
    }

    /*if (this.partSuppPru != null) {
      this.partSuppPru.forEach(x => {
        if (x.Selected)
          approvalBE.SupplierPruTypeList.push(new SupplierPruTypeBE(x.SupplierNo, x.PruId));
      })
    }*/
    // environment.production
    //TODO Do we need to use StartDate more than reading, otherwise use strings and handle in backend?
    this.seqInstrService.sendSequenceInstructionForApproval(approvalBE)
      .subscribe(returnObject => this.sendSequenceInstructionForApprovalResponse(returnObject));
  }

  sendSequenceInstructionForApprovalResponse(returnObject: IReturnObject) {
    if (returnObject.ErrorType == ErrorTypeEnum.Error) {
      this.errHandler.emitError(returnObject.ErrorMsg, 'SequenceInstructionComponent.senSequenceInstructionForApprovalResponse', returnObject.ErrorType);
    } else {
      this.currentDlg.close();

      this.setLoadedValues(returnObject);
      if (returnObject.ErrorMsg.length > 0)
        this.info(returnObject.ErrorMsg);
      else
        this.info("The sequence instruction was successfully sent to the supplier(s)");
    }

    this.showSpinner = false;
  }

  openInstruction(piId: number) {
    this.selectedInstructionId = piId;
    this.pendingAction = this.loadPi;
    this.countinueWithoutSave();
  }

  loadInstruction() {
    this.showSpinner = true;
    clearInterval(this.typeDelayTimer);
    this.errHandler.emitErrorObject(null);
    this.seqInstrService.getInstruction(this.selectedInstructionId)
      .subscribe(returnObject => this.loadInstructionResponse(returnObject));
  }

  loadInstructionResponse(returnObject: IReturnObject) {
    this.instruction = null;
    if (returnObject.ErrorType != ErrorTypeEnum.NoError)
      this.errHandler.emitError(returnObject.ErrorMsg, 'SequenceInstructionComponent.loadInstructionResponse', returnObject.ErrorType);
    else
      this.setLoadedValues(returnObject);
  }

  loadInstructionList(searchTerm: string) {
    this.instructionsList = null;
    this.seqInstrService.getInstructionList(searchTerm, this.user.SupplierNumber, this.user.ExtendedSupplierNumber, this.user.IsPartSupplierUser, this.user.InstructionType)
      .subscribe(returnObject => this.loadInstructionListResponse(returnObject));
  }

  loadInstructionListResponse(returnObject: IReturnObject) {
    if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
      this.errHandler.emitError(returnObject.ErrorMsg, 'SequenceInstructionComponent.loadInstructionListResponse', ErrorTypeEnum.Error);
    }
    else {
      this.instructionsList = <AttributeListBE[]>returnObject.DataList;
    }
  }

  setLoadedValues(returnObject: IReturnObject) {
    this.selectedInstructionId = returnObject.DataList[0].Id;
    this.instruction = <SequenceInstructionItem>returnObject.DataList[0];
    if(this.instruction.StatusId == 6)
    {
      this.instruction.Parts = this.instruction.Parts;
      this.instruction.SupplierInfo = this.instruction.SupplierInfo;
    }
    else{
      this.instruction.Parts = this.instruction.Parts.filter(x => x.IsActive == true);
      this.instruction.SupplierInfo = this.instruction.SupplierInfo.filter(x => x.IsActive == true);
    }

    this.instruction.TotalPartWeight=this.instruction.TotalPartWeight;
    this.instruction.tempSIname=this.instruction.SIName;//set the saved name from backend as temp si name
    this.instruction.Description=this.instruction.Description;
    this.unreliablePartText = "";
    this.loadPruList();
    //this.loadSearchPruList();
    this.setInstructionDatesOnLoad();
    this.extractImages();
    this.loadOtherInfos();
    this.newInstructionText = null;
    this.showSpinner = false;
    this.orgName = this.instruction.SIName;
    this.nameExistsClass = "";
    this.duplicatesiname = "";
    this.isDirty = false;
    this.instruction.MessageInfo = this.removeDuplicateValidationStatus();
    this.setQuantityInLevel();
    this.instruction.SIName;
    //this.findUserPruId();

    //check for issuer approver
    if (returnObject.DataList[0].IssuerUserId != "" && returnObject.DataList[0].IssuedByUserName == "-" && returnObject.DataList[0].IssuedByDepartment == "-")
      this.errHandler.emitError("Issuer " + returnObject.DataList[0].IssuerUserId.toUpperCase() + " doesnt exists in AD, Kindly raise a issue through Customer support to replace user " + returnObject.DataList[0].IssuerUserId.toUpperCase() + " in PackIT.", '', ErrorTypeEnum.Error);

    if (returnObject.DataList[0].ApproverUserId != "" && returnObject.DataList[0].ApprovedByUserName == "-" && returnObject.DataList[0].ApprovedByDepartment == "-")
      this.errHandler.emitError("Approver " + returnObject.DataList[0].ApproverUserId.toUpperCase() + " doesnt exists in AD, Kindly raise a issue through Customer support to replace user " + returnObject.DataList[0].ApproverUserId.toUpperCase() + " in PackIT.", '', ErrorTypeEnum.Error);


    }


  loadOtherInfos() {
    if (this.instruction.Comment != null && this.instruction.Comment.trim().length > 0)
      this.otherInfos = this.instruction.Comment != null ? this.instruction.Comment.trim().split("|") : "".split("|");
    else
      this.otherInfos = [];
  }

  removeDuplicateValidationStatus() {
    let unique = this.instruction.MessageInfo.filter(function (elem, index, self) {
      return index == self.indexOf(elem);
    })
    return unique;
  }



  createDuplicate() {
    this.isDuplicate=true;
    this.instruction.Id = -1;
    this.unreliablePartText = "";

    //si name to be fetched from db post duplicate check
    this.newInstructionText = this.instruction.nextSIname;
    this.instruction.IssuedAt = this.user.Department;
    this.instruction.StringStartDate = this.dateFormatter.toDateStringYYYYMMDDHHMI(new Date(Date.now()));
    this.instruction.StringCreatedDate = this.dateFormatter.toDateStringYYYYMMDDHHMI(new Date(Date.now()));
    this.instruction.IssuedByDepartment = this.user.Department;
    this.instruction.IssuedByUserName = this.user.UserName;
    this.instruction.IssuedByEmail=this.user.Email;
    this.instruction.ApprovedByDepartment = "";
    this.instruction.ApprovedByUserName = "";
    this.instruction.SIName = this.newInstructionText;
    this.instruction.StatusId = 1;
    this.instruction.StatusDescription = "Preliminary";
    this.instruction.Version = 1
    this.instruction.IssuerUserId = this.user.UserId;
    this.instruction.ApproverUserId = "";
    this.orgName = this.instruction.SIName;
    this.nameExistsClass = "";
    this.isDirty = true;
    this.showSpinner = false;
    this.instruction.SendPreliminaryToMona = false;
    this.setStartEndCalenderValues();
  }

  setInstructionStartEndDate() {
    this.instruction.StringStartDate = this.dateFormatter.format(this.startDate);
    this.instruction.StringCreatedDate = this.dateFormatter.format(this.createDate)
  }

  setStartEndCalenderValues() {
    this.startDate = this.dateFormatter.parse(this.instruction.StringStartDate);
    this.createDate = this.dateFormatter.parse(this.instruction.StringCreatedDate);

  }

  setInstructionDatesOnLoad() {
    if (this.instruction.PiCreatedDate == null) {
      this.instruction.PiCreatedDate = new Date(Date.now());
      this.instruction.StringCreatedDate = this.instruction.PiCreatedDate.toISOString();
      this.setStartEndCalenderValues();
    }
    else {
      this.setStartEndCalenderValues();
    }
  }

  setNewInstructionData() {
    this.showSpinner = true;
    this.unreliablePartText = "";
    this.instruction = new SequenceInstructionItem();
    this.instruction.CategoryDescription = "Sequence Instruction";
    this.instruction.IssuedAt = this.user.Department;
    this.instruction.StringStartDate = this.dateFormatter.toDateStringYYYYMMDDHHMI(new Date(Date.now()));
    this.instruction.StringCreatedDate = this.dateFormatter.toDateStringYYYYMMDDHHMI(new Date(Date.now()));
    this.instruction.IssuedByDepartment = this.user.Department;
    this.instruction.IssuedByUserName = this.user.UserName;
    this.instruction.IssuedByEmail=this.user.Email;
    this.instruction.LevelInfo.push(new PkgInstrLevelInfo(1));
    this.instruction.LevelInfo.push(new PkgInstrLevelInfo(2));
    this.instruction.LevelInfo.push(new PkgInstrLevelInfo(3));
    this.instruction.LevelInfo.push(new PkgInstrLevelInfo(99));

    this.instruction.StatusDescription = "Preliminary";
    this.instruction.IssuerUserId = this.user.UserId;
    this.isDirty = true;
    this.showSpinner = false;
    this.pictureLabels = "";
    this.partSuppPru = [];
    this.otherInfos = [];
    this.newInstructionText = "NEW";
    this.orgName = "";
    this.nameExistsClass = "";
    this.setStartEndCalenderValues();
   this.clearPruListSelections();

  }


  // ----------------------------------------------------------
  // Images handling
  // ----------------------------------------------------------
  extractImages() {
    this.pictureIdS = [];
    ImageCommon.SetBase64Image(this.instruction.Pictures);
    this.instruction.Pictures.forEach(x => this.pictureIdS.push(x.Id));
    this.pictureLabels = ImageCommon.setPictureLabels(this.instruction.Pictures);
    this.PITitle = this.instruction.SIName;
    this.piImageId = this.pictureIdS;
  }

  selectImageToInstr(addedImage: any) {
    if (this.selectedImages.indexOf(addedImage.Id) === -1) {
      this.selectedImages.push(addedImage.Id);
      this.imageSearchResult.push(addedImage);
    } else {
      this.selectedImages.splice(this.selectedImages.indexOf(addedImage), 1);
      this.imageSearchResult.splice(this.imageSearchResult.indexOf(addedImage.Id), 1);
    }
  }

  addImageToInstruction() {
    for (var i = 0; i < this.selectedImages.length; i++) {
      if (this.pictureIdS.indexOf(this.selectedImages[i]) === -1) {
        var imageObj = this.imageSearchResult.find(x => x.Id === this.selectedImages[i]);
        this.instruction.Pictures.push(imageObj);
      }
    }

    this.refreshPictureIds();
    ImageCommon.setPictureLabels(this.instruction.Pictures);
    this.imageSearchResult = [];
    this.closeAddImageDlg();
    this.info("Image's added.");
    this.setDirty();
  }

  deleteImageFromInstruction(imageId: number) {
    ImageCommon.RemovePic(this.instruction.Pictures, imageId);
    this.refreshPictureIds();
    this.pictureLabels = ImageCommon.setPictureLabels(this.instruction.Pictures);
    this.info("The picture was removed from the instruction.");
    this.closeDeleteImageDlg();
    this.setDirty();
  }

  refreshPictureIds() {
    this.pictureIdS = []
    this.instruction.Pictures.forEach(x => this.pictureIdS.push(x.Id));
  }
  // ----------------------------------------------------------
  // History
  // ----------------------------------------------------------
  loadHistory() {
    this.dashBoardService.getHistoryFor(this.selectedInstructionId, this.user.SupplierNumber)
        .subscribe(returnObject => this.loadHistoryResponse(returnObject));
  }

  loadHistoryResponse(returnObject: IReturnObject) {
    if (returnObject.ErrorType != ErrorTypeEnum.NoError)
      this.errHandler.emitError(returnObject.ErrorMsg, 'SequenceInstructionComponent.loadHistoryResponse', returnObject.ErrorType);

    else {
      this.historyList = returnObject.DataList;

      this.showHistorySpinner = false;
    }
  }


  // ----------------------------------------------------------
  // Weight and deviation
  // ----------------------------------------------------------
 async  setWeights() {
    this.partWeight = (this.instruction.Parts != null && this.instruction.Parts.length > 0)
      ? this.instruction.Parts[0].Weight
      : 0;

    //this.totalPartWeight = this.partWeight * this.getLevel1QuantityIn() * this.getLevel1QuantityOf();
    this.totalPackaginWeight = this.getAdditionalMaterialWeight() + this.getCodeMaterialWeight();
    //this.grossWeight = this.totalPartWeight + this.totalPackaginWeight;
    this.grossWeight=this.instruction.TotalPartWeight+this.totalPackaginWeight;

    if(this.instruction.SupplierInfo.length > 0){
      this.instructionSupplierList;
      this.instructionSupplierList=await  this.createlist(this.instruction.SupplierInfo)
    }
  }

  async createlist(lists) {
    var supplierList = []
    for (let list of lists){
      let arr = list.SupplierName.split('-');
      let obj = { "name": arr[1], "number": arr[0].trim() }
      await supplierList.push(obj);
    }
    return supplierList;
  }

  getLevel1QuantityIn() {
    return this.instruction.LevelInfo[0].QuantityInLevel;
  }

  getLevel1QuantityOf() {
    return this.instruction.LevelInfo[0].QuantityOfLevel;
  }

  getAdditionalMaterialWeight(): number {
    let weight: number = 0;
    for (let level of this.instruction.LevelInfo) {
      for (let material of level.AdditionalMaterials)
        weight += material.Quantity * material.Weight;
    }
    return weight;
  }

  getCodeMaterialWeight(): number {
    let weight: number = 0;
    for (let level of this.instruction.LevelInfo) {
      for (let material of level.CodeMaterials) {
        weight += level.QuantityOfLevel * material.Quantity * material.Weight;
      }
    }
    return weight;
  }

  getMaxLenth(): number {
    return this.instruction.LevelInfo[0].Length;
  }

  getMaxWidth(): number {
    return this.instruction.LevelInfo[0].Width;
  }

  getMaxHeight(): number {
    return this.instruction.LevelInfo[0].Height;
  }


  // ----------------------------------------------------------
  // Level helpers
  // ----------------------------------------------------------
  setQuantityInLevel() {
    let levels = this.instruction.LevelInfo;
    if (levels[0].PackagingCode.length == 0)
      this.resetLevelProperties();

    levels[1].QuantityInLevel = this.getLevel3Quantity() == 0
      ? levels[1].QuantityInLevel
      : this.getLevel3Quantity();

    levels[0].QuantityInLevel = this.getLevel2Quantity() == 0
      ? levels[0].QuantityInLevel
      : this.getLevel2Quantity();

    this.setWeights();
  }

  resetLevelProperties() {
    for (let i = 0; i < this.instruction.LevelInfo.length; i++) {
      let additionalMtrl = this.instruction.LevelInfo[i].AdditionalMaterials;
      let level = i < 3 ? i + 1 : 99
      this.instruction.LevelInfo[i] = new PkgInstrLevelInfo(level);
      this.instruction.LevelInfo[i].AdditionalMaterials = additionalMtrl;
    }
  }

  getLevel3Quantity() {
    let level = this.instruction.LevelInfo[2];
    if (level.CodeMaterials.length > 0)
      return level.QuantityInLevel * level.QuantityOfLevel;
    else
      return 0;
  }

  getLevel2Quantity() {
    let level = this.instruction.LevelInfo[1];
    if (level.CodeMaterials.length > 0)
      return level.QuantityInLevel * level.QuantityOfLevel;
    else
      return 0;
  }

  levelDataExists(level: number) {
    return this.instruction.LevelInfo[level].CodeMaterials.length > 0
      || this.instruction.LevelInfo[level].AdditionalMaterials.length > 0
  }

  onEditLevel(modal: any, level: number) {
    if (level < 3)
      this.hasSubLevelCode = this.instruction.LevelInfo[level + 1].PackagingCode != "";

    this.errHandler.emitErrorObject(null);
    this.editLevelData = this.instruction.LevelInfo[level];
    this.currentDlg = this.modalService.open(modal, { size: 'lg' });
  }

  deleteLevelCode(levelInfoIndex: number) {
    let tempAdditionalMaterials = this.instruction.LevelInfo[levelInfoIndex].AdditionalMaterials;
    this.instruction.LevelInfo[levelInfoIndex] = new PkgInstrLevelInfo(levelInfoIndex + 1);
    this.instruction.LevelInfo[levelInfoIndex].AdditionalMaterials = tempAdditionalMaterials;
  }

  onEditLevelDialogExecute(dialogResult: PkgInstrLevelInfo) {
    // RULE 0: nothing changed - do nothing
    if (dialogResult == null) {
      this.closeDlg();
      return;
    }

    this.closeDlg();
    this.setDirty();

    if (dialogResult.Level === 1 && dialogResult.ConstraintCodeId !== null) {
      // contraint code was selected. Set level 1 and get constraint code
      this.instruction.LevelInfo[0] = dialogResult;
      this.loadCodeConstraint(dialogResult.ConstraintCodeId, dialogResult.CodeId)
    }
    else if (dialogResult.Level === 1 && dialogResult.ConstraintCodeId === null) {
      // Code with no contraint selected on level 1

      // If the current code has a constraint, then remove any codes
      // but no additional materials on lower levels
      if (this.instruction.LevelInfo[0].ConstraintCodeId != null) {
        this.deleteLevelCode(1);
        this.deleteLevelCode(2);
      }

      this.instruction.LevelInfo[0] = dialogResult;

      // If the user deleted code, then deleta all codes on lower levels
      if (this.instruction.LevelInfo[0].PackagingCode.length === 0) {
        this.deleteLevelCode(1);
        this.deleteLevelCode(2);
        this.setQuantityInLevel();
        return;
      }
    }
    else if (dialogResult.Level === 2) {
      this.instruction.LevelInfo[1] = dialogResult;
      // If the user deleted code, then deleta all codes on lower levels
      if (this.instruction.LevelInfo[1].PackagingCode.length === 0) {
        this.deleteLevelCode(2);
      }
    }
    else if (dialogResult.Level == 3) {
      this.instruction.LevelInfo[2] = dialogResult;
    }
    else if (dialogResult.Level == 99) {
      this.instruction.LevelInfo[3] = dialogResult;
    }
    else {
      this.setQuantityInLevel();
      return;
    }

    this.setQuantityInLevel();
  }

  loadCodeConstraint(constraintCodeId: number, mainCodeId: number) {
    this.showSpinner = true;
    this.seqInstrService.getLevelConstraintData(constraintCodeId, mainCodeId)
      .subscribe(returnObject => this.loadCodeConstraintResult(returnObject));
  }

  loadCodeConstraintResult(returnObject: IReturnObject) {
    if (returnObject.ErrorType != ErrorTypeEnum.NoError)
      this.errHandler.emitError(returnObject.ErrorMsg, 'SequenceInstructionComponent.loadCodeConstraint', returnObject.ErrorType);
    else {
      let levelInfo: PkgInstrLevelInfo = returnObject.DataList[0];
      levelInfo.AdditionalMaterials = this.instruction.LevelInfo[1].AdditionalMaterials;
      levelInfo.Level = 2;

      this.instruction.LevelInfo[1] = levelInfo;
      this.setQuantityInLevel();
    }
    this.showSpinner = false;
  }

  // ----------------------------------------------------------
  // LongTerm
  // ----------------------------------------------------------

loadPruList() {
    this.showUnitLoadingAnimation = true;
    this.seqInstrService.getPruList()
      .subscribe(returnObject => this.loadPruListResponse(returnObject));
  }

  loadPruListResponse(returnObject: IReturnObject) {
   // alert("you have reached loadPruList Response");
    if (returnObject.ErrorType != ErrorTypeEnum.NoError)
      this.errHandler.emitError(returnObject.ErrorMsg, 'PackagingInstructionComponent.loadPruList', returnObject.ErrorType);
    else {
      this.pruList = returnObject.DataList;
      let pnl=this.pruList.find(x => x.Description == "P&L");
      this.pruList=this.pruList.filter(x=>x.Description!=="P&L");
      this.pruList.splice(0,0,pnl);//Adding P&L at the top of list
      let sl=this.pruList.find(x => x.Description == "SL");
      this.pruList=this.pruList.filter(x=>x.Description!=="SL");
      this.pruList.splice(1,0,sl);
      this.instruction.PruRelations.filter(x => {
        this.pruList.find(y => y.Id == x).Selected = true;
      });

      PnL = this.pruList.find(x => x.Description == "P&L").Id;
      CW2 = this.pruList.find(x => x.Description == "SL").Id;

      //to store names of pru codes in array string to display it if user is SUpplier
      if (this.pruList != null) {
        //get the name of all pru units
        this.pruList.forEach(item => {
          if (item.Selected === true) {
            let pruname= item.Description ;
            this.prunames.push(pruname);
          } });

        //to remove duplicates if any
          this.prunames = this.prunames.filter(
          (thing, i, arr) => arr.indexOf(thing) === i
        );
      }
    }

    this.showUnitLoadingAnimation = false;
  }

  uncheckPruItemRelations(clickedPruItem: AttributeListBE) {
    this.isDuplicate=false;

    this.setDirty();

    if (this.partSuppPru == null)
      return;
    this.partSuppPru.forEach(item => {
      if (!clickedPruItem.Selected
        && item.PruMCCodeName == clickedPruItem.Description) {
        let index = this.instruction.PartRelations.findIndex(x => x.Id == item.Id);
        if (index != -1) {
          this.instruction.PartRelations.splice(index, 1);
          item.Selected = false;
        }
      }

    });
  }

  clearPruListSelections(): any {
    this.instruction.PruRelations = [];
    this.pruList.forEach(x => x.Selected = false);
    this.instruction.SendPreliminaryToMona = false;

  }


  updateSelectedPruItems() {
    if (this.isAtLeasOnePart()) {
      this.instruction.PruRelations = [];
      let partId = this.instruction.Parts[0].PartId;
      this.pruList.forEach(pruItem => {
        if (pruItem.Selected)
          this.instruction.PruRelations.push(pruItem.Id);
      });
    }
  }

  updateSupplierList(){
    if(this.isAtLeasOneSupplier())
    {
      this.instruction.SupplierInfo = [];

    }
  }

  performPreSaveChecks() {
    this.showSpinner = true;

    this.updateSelectedPruItems();

    if (this.isAtLeasOnePart()) {
      let pkgInstrObjectToPost = this.preparePkgInstrToPost();

      this.seqInstrService.isFirstSIWithPnl(pkgInstrObjectToPost)
          .subscribe(responseObj => this.isFirstPIWithPnlResponse(responseObj));
    }
    else{
      this.chooseSaveType();
    }
  }


  isFirstPIWithPnlResponse(returnObject: IReturnObject) {

    if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
      this.errHandler.emitError(returnObject.ErrorMsg,
        'SequenceInstructionComponent.isFirstPIWithPnlResponse',
        returnObject.ErrorType);
    }
    else {
      if (returnObject.DataList[0] == true) {
        this.addPnlAndStsToPkgInstr();
        flagPnL = "P&L, ";
      }
      let pkgInstrObjectToPost = this.preparePkgInstrToPost();
      this.seqInstrService.checkConflict(pkgInstrObjectToPost)
          .subscribe(responseObj => this.checkConflictResponse(responseObj));
    }
  }
abc(id:number):string{
  return "Hello";
}
  checkConflictResponse(returnObject: IReturnObject) {

    if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
      this.errHandler.emitError(returnObject.ErrorMsg, 'SequenceInstructionComponent.checkConflict', returnObject.ErrorType);
    }
    else {
       // debugger;
      this.conflictResponseObj = returnObject.DataList;

      //exclude NoConflict items
      //this.conflictResponseObj = this.conflictResponseObj.filter(x => x.ConflictType != ConflictTypeEnum.NoConflict);

      if (this.conflictResponseObj.length == 0 || this.conflictResponseObj[0].ConflictType==0) {
      //change if condition this does not work

        this.chooseSaveType();
      }
      else
      {
        var Ids:number[]=[];
        for(let i=0;i<this.conflictResponseObj.length;i++)
        {// store all the conflicting ids to compare them for the one that repeat
          var id=this.conflictResponseObj[i].PkgInstrId;

          Ids.push(id);
         this.Instruction_Type(id);
        }
        Ids.sort((n1,n2) => n1 - n2); //sort the array
         this.uniqueIds=Ids.filter((element, index) => {
          return Ids.indexOf(element) === index;
          });;

        this.currentConflictDlg = this.modalService.open(this.conflictPruDlg, {
          size: 'lg',
          backdrop: 'static',
          keyboard: false
        });
      }
    }
    this.showSpinner = false;
  }
  PI_SI_Type:number []=[];
  Instruction_Type(id_no:number)
  {
    for(let i=0;i<this.conflictResponseObj.length;i++)
        {// store all the conflicting ids to compare them for the one that repeat
           if(id_no==this.conflictResponseObj[i].PkgInstrId)
           {
            this.PI_SI_Type[id_no]=this.conflictResponseObj[i].Type;
           }
          
        }
  }
  conflictPartandName(id:number,flag:number):string{

    //to display instruction name and part number
    var name:string=" ";
    if(flag==1)
    {// for part
      name=" ";
      this.conflictResponseObj.forEach(item=>{
        if(item.PkgInstrId==id)
        {
          name=name+item.PartNo+",  ";
        }
      });
      name=name.substring(0,name.lastIndexOf(','));
      return name;
    }
    else{
      //for instruction name
      name=" ";
      name=this.conflictResponseObj.find(x=>x.PkgInstrId==id).PIName;

      return name;
    }

  }
  chooseSaveType() {
    if (this.sendToSupplierOrAccept == "activate")
      this.performSendForApproval();
    else
       this.saveInstruction();
  }

  /*performActionConflictDlg() {
    console.log("type of conflict"+this.conflictResponseObj[this.activeConflictItemId].ConflictType);
    if (this.conflictResponseObj[this.activeConflictItemId].ConflictType == ConflictTypeEnum.LastUnitConflict) {
      this.seqInstrService.scrapSeqInstr(this.conflictResponseObj[this.activeConflictItemId].PkgInstrId)
        .subscribe(x => this.scrapPkgInstrResponse(x));
    }
     else if (this.conflictResponseObj[this.activeConflictItemId].ConflictType == ConflictTypeEnum.NormalUnitConflict) {
      this.seqInstrService.UncheckPruRelationforSI(this.conflictResponseObj[this.activeConflictItemId], this.instruction.SIName)
             .subscribe(x => this.uncheckPruRelationforPiResponse(x));
     }
    else if (this.conflictResponseObj[this.activeConflictItemId].ConflictType == ConflictTypeEnum.DifferentLevelAssetsConflict) {
      this.cancelActionConflictDlg();
    }

  }*/

  cancelActionConflictDlg() {
    if (this.sendToSupplierOrAccept == "activate")
      this.closeSendApprovalDlg();
    this.currentConflictDlg.close();
  }

  updateConflictPopup() {
    this.activeConflictItemId++;
    if (this.activeConflictItemId == this.conflictResponseObj.length) {
      //to continue to show all conflict in a row to user.
      this.performPreSaveChecks();
      this.currentConflictDlg.close()
    }
  }

  uncheckPruRelationforPiResponse(returnObject: IReturnObject) {
    if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
      this.errHandler.emitError(returnObject.ErrorMsg, 'SequenceInstructionComponent.UncheckPruRelationforPi', returnObject.ErrorType);
    }
    else {
      this.updateConflictPopup();
      this.info("Conflicting unit relation is successfully unchecked.");
    }
  }

  scrapPkgInstrResponse(returnObject: IReturnObject) {
    if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
      this.errHandler.emitError(returnObject.ErrorMsg, 'SequenceInstructionComponent.scrapPkgInstr', returnObject.ErrorType);
    }
    else {
      this.updateConflictPopup();
      this.info("Conflicting Sequence Instruction is successfully scrapped.");
    }
  }

  addPnlAndStsToPkgInstr() {
    if (!this.isTherePnlInPkgInstr())
      this.instruction.PruRelations.push(PnL);
    this.instruction.SendPreliminaryToMona = true;
  }

  isTherePnlInPkgInstr(): boolean {
    return this.instruction.PruRelations.findIndex(x => x == PnL) == -1
      ? false
      : true;
  }

  getPruName(pruid: number): string {
    return this.pruList.find(x => x.Id == pruid).Description;
  }

  // ----------------------------------------------------------
  // Pru/supplier list data
  // ----------------------------------------------------------
  loadSearchPruList() {
    this.showSupplierRelLoadingAnim = true;
    if (this.instruction.Parts.length > 0) {
      this.partSupplierPruService.searchPruByPruNameFor(this.instruction.Parts[0].PartNo)
        .subscribe(returnObject => this.loadSearchPruListResponse(returnObject));
    }
  }

  loadSearchPruListResponse(returnObject: IReturnObject) {
    this.errHandler.emitErrorObject(null);
    this.partSuppPru = null;
    if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
      this.errHandler.emitError(returnObject.ErrorMsg, 'SequenceInstructionComponent.loadSearchPruListResponse', returnObject.ErrorType);
    } else {
      let isValid = this.isSupplierRelationResponseValid(returnObject);
      if (isValid) {
        this.partSuppPru = returnObject.DataList;
        let selPartRelations: PArray<PartSupplierPruBe> = new PArray(this.instruction.PartRelations);
        for (var i = 0; i < this.partSuppPru.length; i++) {
          this.partSuppPru[i].Selected = selPartRelations.getItemByProperty('Id', this.partSuppPru[i].Id) != null;
        }
      }
    }
    this.showSupplierRelLoadingAnim = false;
  }

  isSupplierRelationResponseValid(returnObject: IReturnObject) {
    if (returnObject.DataList.length > 0) {
      if (returnObject.DataList[0].Id != null) {
        return true;
      }
    }
    return false;
  }

  /*setPartPkgRelation(psItem: PartSupplierPruBe) {

    let relationId = psItem.Id
    let pRelation: PArray<PartSupplierPruBe> = new PArray(this.partSuppPru);
    let inx = pRelation.getIndexByProperty('Id', relationId);
    let inx2 = this.partSuppPru.findIndex(x => x.Id == relationId);

    if (inx == null)
      return;

    this.partSuppPru[inx].Selected = !this.partSuppPru[inx].Selected;

    // Reset selected pru's in instruction from partSuppPru array
    this.instruction.PartRelations = [];
    for (var i = 0; i < this.partSuppPru.length; i++) {
      if (this.partSuppPru[i].Selected)
        this.instruction.PartRelations.push(new PartSupplierPruBe(this.partSuppPru[i].Id));
    }

    //When supplier Relation selected, auto-select related pru.
    if (psItem.Selected) {
      this.pruList.find(x => x.Id == psItem.PruId).Selected = true;
    }

    this.setDirty();
  }*/



  // ----------------------------------------------------------
  // Other info
  // ----------------------------------------------------------
  addOtherInfo() {
    if (this.instruction.Comment.length == 0)
      this.instruction.Comment = this.newOtherInfo;
    else
      this.instruction.Comment = this.instruction.Comment + '|' + this.newOtherInfo;
    this.otherInfos = this.instruction.Comment != null ? this.instruction.Comment.split("|") : "".split("|");
    this.newOtherInfo = '';
    this.isDirty = true;
  }

  deleteOtherInfo(textToFind: string) {
    var inx = this.otherInfos.indexOf(textToFind);
    this.otherInfos.splice(inx, 1)
    this.instruction.Comment = this.otherInfos.length > 0 ? this.otherInfos.join('|') : '';
    this.isDirty = true;
  }

  moveInfoTextUp(infoText: string) {
    this.moveInfoText(infoText, -1);
  }

  moveInfoTextDown(infoText: string) {
    this.moveInfoText(infoText, 1);
  }

  moveInfoText(infoText: string, steps: number) {
    let inx: number = this.otherInfos.indexOf(infoText);
    let newInx = (inx + steps) < 0 ? 0 : inx + steps;
    this.otherInfos.splice(inx, 1);
    this.otherInfos.splice(newInx, 0, infoText);
    this.instruction.Comment = this.otherInfos.length > 0 ? this.otherInfos.join('|') : '';
    this.isDirty = true;
  }

  updateOtherInfo() {
    this.instruction.Comment = "";
    this.otherInfos.forEach(x => {
      if (this.instruction.Comment == "")
        this.instruction.Comment = x;
      else
        this.instruction.Comment = this.instruction.Comment + "|" + x;
    });
  }
  validateMhInLevel(): boolean {
    this.Mhnumber = [];

    this.instruction.LevelInfo.forEach(element => {
      if (element.AdditionalMaterials != null) {
        element.AdditionalMaterials.forEach(insideelement => {
          if (insideelement.MHNo != null) {
            this.Mhnumber.push(insideelement.MHNo);
          }
        })
      }
    })
    this.instruction.LevelInfo.forEach(element => {
      if (element.CodeMaterials != null) {
        element.CodeMaterials.forEach(insideelement => {
          if (insideelement.MHNo != null) {
            this.Mhnumber.push(insideelement.MHNo);
          }
        })
      }
    })
    let findDuplicates = arr => arr.filter((item, index) => arr.indexOf(item) != index)
    let duplicateValues = findDuplicates(this.Mhnumber)
    if (duplicateValues.length > 0) {
      if (duplicateValues.every(v => this.Exclusionlist.includes(v))) {
        return true;

      } else {
        // this.openOnSaveValidateDlg("Same material " + duplicateValues + " cannot be added in same Packaging Instruction more than once");
        return false;
      }
    } else { return true; }
  }

  findCommonElements(arr1, arr2) {
    return arr1.some(item => arr2.includes(item))
  }

  getMaterialExclusions() {
    this.materialAttrService.getMaterialExclusions()
      .subscribe(returnObject => {
        this.fillExclusionList(returnObject.DataList);

      });

  };
  fillExclusionList(dataList: AttributeListBE[]) {
    dataList.forEach(element => {
      if (element.MHno != null) {
        this.Exclusionlist.push(element.MHno)
      }
    })
  }

  customTrackBy(index: number, obj: any): any {
    return index;
  }

  // ----------------------------------------------------------
  // searchPart methods
  // ----------------------------------------------------------
  addPartToInstruction(part: Array<PartListBE>): void {
    this.closeDlg();
    if (part == null)
      return;
    //else
    //  this.clearPruListSelections();

      this.showSpinner = true;
      this.isDuplicate=false; //since part is added
    this.errHandler.emitErrorObject(null);

    let partIds = new Array<number>();
    part.forEach(p => partIds.unshift(p.Id))

    this.partSupplierPruService.getPartList(partIds) // remove this call
      .subscribe(returnObject => this.addPartToInstructioResult(returnObject));
  }

  addPartToInstructioResult(returnObject: IReturnObject): void { // no need to send part

    let newParts: Array<SequenceInstructionPart>;
    if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
      if (returnObject.ErrorType == ErrorTypeEnum.Warning){


        //this.getPartInfo(part);  //

// balcnk
      }
      else{
        this.errHandler.emitError(returnObject.ErrorMsg, 'SequenceInstructionComponent.addPartToInstructioResult', returnObject.ErrorType);
      }

    }
    else {

      returnObject.DataList[0].Value.forEach(part => {
        let newPart = new SequenceInstructionPart();
        newPart.Id = part.Id;
        newPart.PartId = part.PartId;
        newPart.PartNo = part.PartNo;
        newPart.Description = part.ShortDescription;
        newPart.Weight = part.Weight;
        newPart.WeightCode = part.WeightCode;
        const partNoList = this.instruction.Parts.map(p => p.PartNo)
        if(!partNoList.includes(part.PartNo)) {
          this.instruction.Parts.unshift(newPart);

        }
      });


    //  newPart.IsMultiPart = part.IsMultiPart;
       // push a list of parts ( retrun object)
      /* this.instruction.tempSIname=this.instruction.SIName;
      this.instruction.SIName = `${this.instruction.Parts[0].Description}`;
      console.log("tempSI "+this.instruction.tempSIname);
      console.log("SIname "+this.instruction.SIName);*/

    //  this.loadPruList();
     // this.loadSearchPruListResponse(returnObject);

      // this.loadExistingConsistingParts(partPruSuppList[0].PartNo); // ??
      // console.log("loadExistingConsistingParts")

      this.checkNameUnique();

      this.setQuantityInLevel();

      if (this.instruction.Pictures == null || this.instruction.Pictures.length == 0) {
        this.pictureLabels = this.instruction.SIName;
        this.PITitle = this.instruction.SIName;

    }
    this.isDirty = true;
    this.showSpinner = false;

    // this.instruction.SIName = this.instruction.Parts[0].Description == undefined
    // ? `${this.instruction.Parts[0].PartNo}`
    // : `${this.instruction.Parts[0].PartNo}-${this.instruction.Parts[0].Description}`;
  // this.loadExistingConsistingParts(newPart.PartNo); // ??
  this.checkNameUnique();
  this.setQuantityInLevel()
  if(this.pruList.length == 0 )
 {
  this.clearPruListSelections();
  this.loadPruList();
}

  if (this.instruction.Pictures == null || this.instruction.Pictures.length == 0) {
    this.pictureLabels = this.instruction.Parts[0].PartNo;
    this.PITitle = this.instruction.Parts[0].PartNo;
  }
}
this.isDirty = true;
this.showSpinner = false;
  }


  // getPartInfo(partId: number) {
  //   console.log("getPartInfo 1")

  //   clearInterval(this.typeDelayTimer);
  //   this.errHandler.emitErrorObject(null);
  //   this.partSupplierPruService.getPartInfo(partId)
  //     .subscribe(returnObject => this.getPartInfoResponse(returnObject));
  // }

  getPartInfoResponse(returnObject: IReturnObject): void {
    
    if (returnObject.ErrorType != ErrorTypeEnum.NoError) {

      this.errHandler.emitError(returnObject.ErrorMsg, 'SequenceInstructionComponent.addPartToInstructioResult', returnObject.ErrorType);
    }
    else {
      let newPart: SequenceInstructionPart = returnObject.DataList[0];
      this.instruction.Parts.push(newPart);

      this.instruction.SIName = newPart[0].Description == undefined
        ? `${newPart[0].PartNo}`
        : `${newPart[0].PartNo}-${newPart[0].Description}`;
      this.loadExistingConsistingParts(newPart.PartNo);
      this.checkNameUnique();
      this.setQuantityInLevel()

    //  this.loadPruList();

      if (this.instruction.Pictures == null || this.instruction.Pictures.length == 0) {
        this.pictureLabels = newPart.PartNo;
        this.PITitle = newPart.PartNo;
      }
    }
    this.isDirty = true;
    this.showSpinner = false;
  }


  loadExistingConsistingParts(partNo: string) {
    clearInterval(this.typeDelayTimer);
    this.errHandler.emitErrorObject(null);
    this.multiPartService.getConsistingPartsForPart(partNo)
      .subscribe(returnObject => this.loadExistingConsistingPartsResponse(returnObject));
  }

  loadExistingConsistingPartsResponse(returnObject: IReturnObject) {
    if (returnObject.ErrorType != ErrorTypeEnum.NoError)
      this.errHandler.emitError(returnObject.ErrorMsg, 'SequenceInstructionComponent.loadExistingConsistingPartsResponse', returnObject.ErrorType);
    else {
      if (this.instruction.Parts.length > 0) {
        this.instruction.Parts[0].ConsistingParts = null;
        this.instruction.Parts[0].ConsistingParts = returnObject.DataList;
      }
    }

  }


  // ----------------------------------------------------------
  // Dialog boxes and support methods
  // ----------------------------------------------------------
  openOnSaveValidateDlg(text: string) {
    this.errHandler.emitErrorObject(null);
    this.dialogAction = "savefail";
    this.dialogBtnType = "info";
    this.dialogAppliesTo = 'Sequence Instruction';
    this.confirmDlgText = text;
    this.dialogAppliesToId = this.instruction.Id;
    this.currentDlg = this.modalService.open(this.cdlg, { size: 'sm' });
  }

  openOnSendMailValidateDlg(text: string) {
    this.errHandler.emitErrorObject(null);
    this.dialogAction = "savefail";
    this.dialogBtnType = "info";
    this.dialogAppliesTo = 'Sequence Instruction';
    this.confirmDlgText = text;
    this.dialogAppliesToId = this.instruction.Id;
    this.currentDlg = this.modalService.open(this.cdlg, { size: 'lg' });
  }

  openConfirmDeleteDlg() {
    this.errHandler.emitErrorObject(null);
    this.dialogAction = "delete";
    this.dialogBtnType = "danger";
    this.dialogAppliesTo = 'Sequence Instruction';
    this.dialogAppliesToId = this.instruction.Id;
    this.currentDlg = this.modalService.open(this.cdlg, { size: 'sm' });
  }

  onDeletePart(partId: number) {
    this.errHandler.emitErrorObject(null);
    this.dialogAction = "deletepart";
    //Here we actually pass the position of Part and not the actual Part ID
    this.dialogAppliesToId =this.instruction.Parts.findIndex(x=>x.PartId===partId);

    this.dialogAppliesTo = 'part';
    this.dialogBtnType = "danger";
    this.currentDlg = this.modalService.open(this.cdlg, { size: 'sm' });
  }

  confirmContinueWithoutSave() {
    this.errHandler.emitErrorObject(null);
    this.dialogAction = "continuewithoutsave";
    this.dialogBtnType = "warning";
    this.dialogAppliesTo = 'Sequence Instruction';
    this.dialogAppliesToId = this.instruction.Id;
    this.currentDlg = this.modalService.open(this.cdlg, { size: 'sm' });
  }

  onSearchPart(modal: any) {
    this.errHandler.emitErrorObject(null);
    this.currentDlg = this.modalService.open(modal, { size: 'sm' });
  }

  onConfirmDlgNotify(command: ConfirmResult): void {
    if (command.Action == "delete")
      this.deleteInstruction();

    else if (command.Action == "deletepart")
      this.deletePart(command.Id);

    else if (command.Action=="deletesupplier")
      this.deleteSupplier(command.Id);

    else if (command.Action == "continuewithoutsave") {
      this.currentDlg.close();
      if (this.pendingAction != null)
        this.pendingAction();
    }
    else if (command.Action == "cancel") {
      this.pendingAction = null;
      this.currentDlg.close();
    }
    else
      this.currentDlg.close();
  }


  // ----------------------------------------------------------
  // Button bar and support methods
  // ----------------------------------------------------------
  onBtnBarButtonNotify(command: string): void {
    if (command == "new") {
      this.pendingAction = this.newPi;
      this.countinueWithoutSave();
    }
    if (command == "preview")
      this.previewInstruction();

    else if (command == "save" && this.isContentValid())
      this.performPreSaveChecks();

    else if (command == "duplicate") {
      this.pendingAction = this.duplicatePi;
      this.countinueWithoutSave();
    }

    else if (command == "approve" && this.isContentValid() ) {
      this.checkSupplierContactsExist();
    }

    else if (command == "history")
      this.viewHistory();

    else if (command == "delete") {
      this.openConfirmDeleteDlg();
    }
  }

  //PAIT-814
  previewInstruction() {
    let change1 :string;
    change1=this.instruction.SIName.replace(/"/g,' ');
    this.seqInstrService.getPreviewPdf(this.instruction.Id, change1)
      .subscribe(returnObject => this.previewInstructionResponse(returnObject));
  }
 
  previewInstructionResponse(returnObject: any) {
    let change :string;
    change=this.instruction.SIName.replace(/"/g,' ');
    this.instruction.SIName = change;
    window.open(this.config.get('apiUrl') + "/SequenceInstruction/GetPreviewPdfSI/?siId=" + this.instruction.Id + "&siName=" + change, '_blank');
  }
  // previewInstruction() {
  //   this.seqInstrService.getPreviewPdf(this.instruction.Id, this.instruction.SIName)
  //     .subscribe(returnObject => this.previewInstructionResponse(returnObject));
  // }

  // previewInstructionResponse(returnObject: any) {
  //   window.open(this.config.get('apiUrl') + "/SequenceInstruction/GetPreviewPdfSI/?siId=" + this.instruction.Id + "&siName=" + this.instruction.SIName, '_blank');
  // }

  viewHistory() {
    this.errHandler.emitErrorObject(null);
    this.showHistorySpinner = true;
    this.currentDlg = this.modalService.open(this.historyDlg, { size: 'lg' });

    this.loadHistory();
  }

  duplicatePi: any = () => {
    this.pendingAction = null;
    this.createDuplicate();
  }

  newPi: any = () => {
    this.pendingAction = null;
    this.setNewInstructionData();
  }

  loadPi: any = () => {
    this.pendingAction = null;
    this.loadInstruction();
  }

  clickSendForApproval() {
    this.closeDlg();//it prevents error
    if (this.sendToSupplierOrAccept == "activate") {
      this.setDirty();
      this.instruction.SendPreliminaryToMona = true;//it's needed to conflict check
      this.performPreSaveChecks();
    }
    else if (this.sendToSupplierOrAccept == "send") {
      //check for Supplier email
      sendToSupplierVerified = this.isContentValidforSendSeq();
      if (sendToSupplierVerified)
        this.performSendForApproval();
    }
  }

  performSendForApproval() {
    if (this.sendToSupplierOrAccept == "activate")


      this.instruction.StatusId = StatusEnum.Active;
    this.setInstructionStartEndDate();
    this.approveInstruction();
    this.closeSendApprovalDlg();
  }

  countinueWithoutSave() {
    if (this.isDirty)
      this.confirmContinueWithoutSave();
    else
      this.pendingAction();
  }


  // ----------------------------------------------------------
  // PI save and approve validation
  // ----------------------------------------------------------
  isContentValid(): boolean {
        if (!this.isValidConsumingAres()) {
      // this.openOnSaveValidateDlg("One or more consuming area needs to be selected, please select before saving");
      this.openOnSaveValidateDlg("One or more unit needs to be selected, please select before saving");
      return false;
    }
    else if(this.isValidSupplier()){
      this.openOnSaveValidateDlg("One or more supplier needs to be selected, please select before saving");
      return false;

    }
    else if(this.isValidPart()){
      this.openOnSaveValidateDlg("One or more parts needs to be selected, please select before saving");
      return false;
    }
    else if (!this.isValidNumericValues()) {
      this.openOnSaveValidateDlg("One or more of the characters in deviation fields are no numeric, please correct before save");
      return false;
    }

    else if (!this.isValidOtherInfo()) {
      this.openOnSaveValidateDlg("Other info is not correct, plase fix xxxxx");
      return false;
    }

    else if (!this.isValidLevelData()) {
      this.openOnSaveValidateDlg("Please select atleast One Level !");
      return false;
    }

    else if (!this.isValidExclusionData()) {
      this.openOnSaveValidateDlg("Same Material can't be present multple times in One Sequence Instruction !");
      return false;
    }

    else if (!this.isValidDates()) {
      this.openOnSaveValidateDlg("Please enter valid startdate.")
      return false;
    }


    else if (!this.isValidTotalPartWeight()) {
      this.openOnSaveValidateDlg("Please enter total part weight.")
      return false;
    }
    else if (!this.isValiDeviationMeasures()) {
      this.openOnSaveValidateDlg("Please enter deviation from standard measures.")
      return false;
    }


    return true;
  }

  isContentValidforSendSeq(): boolean {
    let suppNos:number[] = [];
    let contact:number[]=[];
    let supplierAbsent:string[]=[];
    if(this.supplierContactList!=null){
      for (var i = 0; i < this.instruction.SupplierInfo.length; i++) {

        //getting only id of all Suppliers
        let supNo:number=this.instruction.SupplierInfo[i].SupplierId;
        suppNos.push(supNo);
     }

     for(var i = 0; i < this.supplierContactList.length; i++)
     {
       //getting only id of Suppliers who have contacts present
       let cont=this.supplierContactList[i].SupplierId;
        contact.push(cont);
     }
     var temp:boolean=JSON.stringify(contact)==JSON.stringify(suppNos);// compares 2 lists in JSON format irraational of its order
     var difference = suppNos.filter(x=>!contact.includes(x));//gives out the list of all missing contact suppliers

     if(!temp)
     {
       if(difference.length>=0)
       {
         for(var i=0;i<difference.length;i++)
         {
          var absent=this.instruction.SupplierInfo.find(x=>x.SupplierId==difference[i]).SupplierName;
          supplierAbsent.push(absent);
         }
       }

       this.openOnSendMailValidateDlg("Suppliers:  \n"+supplierAbsent+"   do not have their contacts \n Please contact your local Administrator,Supplier Setting");
        return false;
     }
     return true;

    }
  }


  isContentValidforSend(): boolean {
    //PAIT-24: check for Supplier PRu selected has contact available
    if (this.partSuppPru != null) {
      for (var i = 0; i < this.partSuppPru.length; i++) {
        if (this.partSuppPru[i].Selected == true && this.partSuppPru[i].SupplierNo != "0000000") {
          var isSparePart = this.partSuppPru[i].IsSparePart;
          var suppId = this.partSuppPru[i].SupplierNo + "- " + this.partSuppPru[i].SupplierName;
          var iscountofemailExists = this.partSuppPru[i].countofemailExists;
          var isPruProd = "";
          if (isSparePart)
            isPruProd = "Parts Logistics";
          else
            isPruProd = "Production";

          if (iscountofemailExists == 0) {
            this.openOnSendMailValidateDlg("There is no Supplier contact mapped to " + isPruProd + " for Supplier " + suppId + ", Please add a supplier contact under Administration, Supplier setting.");
            return false;
          }
          //now check if the pru has contact mapped as per isPartProduction
          /* if (this.sendForApprovalSuppliers != null) {
               for (var i = 0; i < this.sendForApprovalSuppliers.length; i++)
               {
                   if (this.sendForApprovalSuppliers[i].PruId == pruid)
                   {
                       var contactexists ;
                       if(isSparePart)
                       contactexists = this.sendForApprovalSuppliers[i].IsSparePart

                   }
               }
           }  */
        }
      }
    }

    return true;
  }


  isContentValidForApprove(): boolean {
    if (!this.isContentValid())
      return false;

    // In long term it is possible to activate PI even it does not have supplier relation
    // if (!this.isValidPartForApproval()) {
    //     return false;
    // }

    if (!this.isPartActive()) {
      return false;
    }

    return true;
  }

  //[] is it changed after long-term? is PartRelations still needed?
  isValidPartForApproval(): boolean {
    // to be possible to approve there must be one part and at least one consuming are
    var isValid = this.instruction.Parts != null
      && this.instruction.Parts.length > 0
      && this.instruction.PartRelations != null
      && this.instruction.PartRelations.length > 0;

    if (!isValid)
      this.openOnSaveValidateDlg("At least one part and one conuming area has to\nbe selected and saved before approval.");

    return isValid;
  }

  isPartActive(): boolean {
    // customer decided to disable this check.
    // Remove next line return false if customer change their mind
    return true;
  }

  isValidDates(): boolean {
    /**
     * Start date must be selected for approval flow.
     */
    var isValid = this.startDate === null ? false : true;

    if (isValid) {
      if ((this.startDate.year != null
        && this.startDate.month != null
        && this.startDate.day != null) == true) {
        return true;
      }
      return false;
    }
    return false;
  }

  isValidOtherInfo(): boolean {
    // TODO validations ??
    return true;
  }
  isValidSupplier():boolean{
    //To check if the supplier is not empty

    var isValid=(this.instruction.SupplierInfo.length===0)?true:false;

    return isValid;
  }
  isValidPart():boolean{
    //To check if the part is not empty

    var isValid=(this.instruction.Parts.length===0)?true:false;

    return isValid;
  }
  isValidTotalPartWeight(): boolean {
    /**
     * Total part weight must be entered.
     */
    var isValid = ( this.instruction.TotalPartWeight===0) ? false : true;

   return isValid;
}
isValiDeviationMeasures(): boolean {
  /**
   *Deviation measures must be entered
   */
  var isValid = (this.instruction.DeviationWeight === 0 || this.instruction.DeviationHeight === 0 ||
        this.instruction.DeviationLength ===0 || this.instruction.DeviationWidth===0 ) ? false : true;

 return isValid;
}

  isValidLevelData(): boolean {
    if (this.instruction.LevelInfo[0].PackagingCode.length > 0
      && this.instruction.LevelInfo[0].CodeMaterials.length > 0) {
      return true;
    }
    else
      return false;
  }

  isValidExclusionData(): boolean {
    if (this.validateMhInLevel()) {
      //localStorage.clear();
      return true;
    }
    else
     // localStorage.clear();
    return false;
  }

  //[]Is it right?
  isValidConsumingAres(): boolean {
    // If a part is selected then one or more consuming areas has to be
    // checked because the part and part cannot be saved in db without it
    // if (this.instruction.Parts != null && this.instruction.Parts.length > 0)
    //     return this.instruction.PartRelations != null && this.instruction.PartRelations.length > 0;

    return this.isAtLeasOnePart() == true
      ? this.pruList != null && this.pruList.filter(x => x.Selected == true).length > 0
      : true;
  }

  isValidNumericValues(): boolean {
    let checkValues: boolean = Number.isNaN(this.instruction.DeviationHeight)
      && Number.isNaN(this.instruction.DeviationLength)
      && Number.isNaN(this.instruction.DeviationWeight)
      && Number.isNaN(this.instruction.DeviationWidth)
      && Number.isNaN(this.instruction.DeviationHeight)

    return !checkValues;
  }



  // ----------------------------------------------------------
  // info
  // ----------------------------------------------------------
  info(message: string): void {
    this.errHandler.emitError(message, '', ErrorTypeEnum.Info);
  }


  // ----------------------------------------------------------
  // Image Modals
  // ----------------------------------------------------------
  openAddImageToPI(modal: any) {
    this.currentDlg = this.modalService.open(modal, { size: 'lg' });
  }

  openDeleteImageFromPI(modal: any, pictureInfo: any) {
    this.deleteImageInfo = pictureInfo;
    this.currentDlg = this.modalService.open(modal, { size: 'sm' });
  }

  closeAddImageDlg() {
    this.imageSearchResult = [];
    this.selectedImages = [];
    this.currentDlg.close();
  }

  closeDeleteImageDlg() {
    this.currentDlg.close();
  }

  countChange(event: PictureBe) {
    this.imageLibraryEvent = <PictureBe>event;
    this.selectImageToInstr(this.imageLibraryEvent);
  }


  // ----------------------------------------------------------
  // MISC
  // ----------------------------------------------------------
  onLevelDataChanged() {
    this.setDirty();
  }

  setDirty() {
    this.isDirty = true;
  }

  closeDlg() {
    this.currentDlg.close();
  }

  closeSendApprovalDlg() {
    this.currentDlg.close();
    this.sendToSupplierOrAccept = "";
  }


  // ----------------------------------------------------------
  // Check if si name exists when typing
  // ----------------------------------------------------------
  checkNameUnique() {
    if (this.instruction.SIName.length < MIN_NAME_LENGTH) {
      this.nameExistsClass = "";
      return;
    }

    if (this.instruction.SIName == this.orgName) {
      this.nameExistsClass = "";
      return;
    }

    this.seqInstrService.siNameExist(this.instruction.SIName)
      .subscribe(nameExists => this.checkNameUniqueResponse(nameExists));
  }

  checkNameUniqueResponse(nameExists: boolean) {
    this.nameExistsClass = nameExists
      ? "nameExist"
      : "";
  }

  setDefaultBackColor() {
    this.nameExistsClass = "";
  }


  // ----------------------------------------------------------
  // Send for appoval
  // ----------------------------------------------------------
  prepareApprovalDlg() {
    this.sendForApprovalSuppliers = [];
    this.sendToSupplierOrAccept = "send"; //
    this.approvalMessage = "";
    if (this.instruction.SupplierInfo != null) {
      //
      for (var i = 0; i < this.instruction.SupplierInfo.length; i++) {
        if (this.sendForApprovalSuppliers.findIndex(x => x.SupplierNo == this.partSuppPru[i].SupplierNo) == -1) {
          let supp: PartSupplierPruBe = new PartSupplierPruBe(0);
          supp.SupplierName = this.partSuppPru[i].SupplierName;
          supp.SupplierNo = this.partSuppPru[i].SupplierNo;
          supp.PruId = this.partSuppPru[i].PruId;
          supp.IsSparePart = this.partSuppPru[i].IsSparePart;
          supp.countofemailExists = this.partSuppPru[i].countofemailExists;
          var suppSelectedCheck = this.partSuppPru.find(x => x.SupplierNo == supp.SupplierNo && x.Selected == true);
          supp.Selected = suppSelectedCheck != null;
          this.sendForApprovalSuppliers.push(supp);

        }
      }
    }
  }

  isAnyApproveSupplierSelected(): boolean {
    //return this.sendForApprovalSuppliers.findIndex(x => x.Selected == true) == -1;
    return false;

  }


  // ----------------------------------------------------------
  // GUI behaviour
  // ----------------------------------------------------------
  toggleSupplierPanel() {
    this.supplierListVisible = !this.supplierListVisible;
  }

  togglePartsPanel() {
    this.partListVisible = !this.partListVisible;
  }

  togglePrusPanel() {
    this.pruListVisible = !this.pruListVisible;
  }

  isNewOtherInfoEmpty(): boolean {
    return this.newOtherInfo.length == 0 || this.isEditDisabled();
  }

  isPartNotNull(partInfo: SequenceInstructionPart): boolean {
    return partInfo !== null && this.instruction.Parts.length == 0;
  }

  isAtLeasOnePart(): boolean {
    return this.instruction.Parts != null && this.instruction.Parts.length > 0;
  }

  isFirstOtherInfoReocord(infoText: string): boolean {
    return this.otherInfos.indexOf(infoText) == 0;
  }

  isLastOtherInfoReocord(infoText: string): boolean {
    return this.otherInfos.indexOf(infoText) == this.otherInfos.length - 1;
  }


  // ----------------------------------------------------------
  // Access rights
  // ----------------------------------------------------------
  isEditLevelButtonDisabled(level: number): boolean {
    let ruleResult: boolean = false;

    // prevent checks from being run until leveldata has been populated
    if (this.instruction.LevelInfo == null || this.instruction.LevelInfo.length < 4) {
      return true;
    }

    if (level == 0) {
      return this.isEditDisabled();
    }

    if (level == 1) {
      return this.instruction.LevelInfo[0].PackagingCode.length == 0 || this.isEditDisabled();
    }

    if (level == 2) {
      return this.instruction.LevelInfo[1].PackagingCode.length == 0 || this.isEditDisabled();
    }

    if (level == 3) {
      return this.isEditDisabled();;
    }
  }

  isBtnBarHidden(): boolean {
    let gotAccess: boolean =
      (this.user.IsPackagingAdmin
        || this.user.IsPackagingEngineer
        || this.user.IsScaniaUser
        || this.user.IsTestPackager
        || this.user.IsPartSupplierUser
        || this.user.IsDeveloper)
      && this.instructionIdFromParentCtrl == null;

    return !gotAccess;
  }

  isBtnNewDisabled(): boolean {
    let gotAccess: boolean =
      (this.user.IsPackagingAdmin
        || this.user.IsPackagingEngineer
        || this.user.IsTestPackager
        || this.user.IsDeveloper);

    return !gotAccess;
  }

  isBtnDuplicateDisabled(): boolean {
    let gotAccess: boolean =
      (this.user.IsPackagingAdmin
        || this.user.IsPackagingEngineer
        || this.user.IsTestPackager
        || this.user.IsDeveloper)
      && this.instruction != null;

    return !gotAccess;
  }

  isBtnPreviewDisabled(): boolean {
    let gotAccess: boolean =
      (this.user.IsPackagingAdmin
        || this.user.IsPackagingEngineer
        || this.user.IsTestPackager
        || this.user.IsPartSupplierUser
        || this.user.IsPurchaser
        || this.user.IsScaniaUser
        || this.user.IsDeveloper)
      && !this.isDirty // must be saved to be able to view PDF
      && this.instruction != null;

    return !gotAccess;
  }

  isBtnSaveDisabled(): boolean {
    let gotAccess: boolean =
      (this.user.IsPackagingAdmin
        || this.user.IsPackagingEngineer
        || this.user.IsTestPackager
        || this.user.IsDeveloper)
      && this.isDirty
      && this.instruction != null
      && (this.instruction.StatusId == StatusEnum.Preliminary
        || this.instruction.StatusId == StatusEnum.Active || this.instruction.StatusId == StatusEnum.SentToSupplier || this.instruction.StatusId == StatusEnum.SentToMultipleSuppliers)
      && this.nameExistsClass != "nameExist";

    return !gotAccess;
  }

  isBtnApproveDisabled(): boolean {
    let gotAccess: boolean =
      ((this.user.IsPackagingAdmin && this.user.IsScaniaApprover)
        || (this.user.IsPackagingEngineer && this.user.IsScaniaApprover)
        || this.user.IsDeveloper)
      && this.instruction != null
      && this.instruction.StatusId == StatusEnum.Preliminary
      && !this.isDirty // must be saved before approval
      && this.nameExistsClass != "nameExist";

    return !gotAccess;
  }

  isBtnHistoryDisabled(): boolean {
    let gotAccess: boolean =
      (this.user.IsPackagingAdmin
        || this.user.IsPackagingEngineer
        || this.user.IsTestPackager
        || this.user.IsDeveloper
        ||this.user.IsScaniaUser)
      && this.instruction != null
      && this.instruction.Id != -1;

    return !gotAccess;
  }

  isBtnDeleteDisabled(): boolean {
    let gotAccess: boolean =
      (this.user.IsPackagingAdmin
        || this.user.IsPackagingEngineer
        || this.user.IsTestPackager
        || this.user.IsDeveloper)
      && this.instruction != null
      && this.instruction.Id > 0
      && this.instruction.StatusId == StatusEnum.Preliminary;

    let gotAdminAccess: boolean =
      (this.user.IsPackagingAdmin
        || this.user.IsPackagingEngineer
        || this.user.IsDeveloper)
      && this.instruction != null
      && this.instruction.Id > 0
      && this.instruction.StatusId > StatusEnum.Preliminary;

    return !(gotAccess || gotAdminAccess);
  }

  isSearchHidden(): boolean {
    let gotAccess: boolean =
      (this.user.IsPackagingAdmin
        || this.user.IsPackagingEngineer
        || this.user.IsPurchaser
        || this.user.IsTestPackager
        || this.user.IsPartSupplierUser
        || this.user.IsDeveloper
        || this.user.IsScaniaUser)
      && this.instructionIdFromParentCtrl == null;

    return !gotAccess;
  }

  isEditDisabled(): boolean {
    let gotAccess: boolean =
      (this.user.IsPackagingAdmin
        || this.user.IsPackagingEngineer
        || this.user.IsTestPackager
        || this.user.IsDeveloper)
      && this.instructionIdFromParentCtrl == null
      && this.instruction != null
      && (this.instruction.StatusId == StatusEnum.Preliminary )

    return !gotAccess;
  }

  isEditConsumingArea(): boolean {  //not used in sequence

    //if all the conditions are satisfied gotaccess is true .Hence it should not be disabled and return false
    let gotAccess: boolean =
    (this.user.IsPackagingAdmin
      || this.user.IsPackagingEngineer
      || this.user.IsTestPackager
      || this.user.IsDeveloper)
      && this.instructionIdFromParentCtrl == null
      && this.instruction != null
      && (this.instruction.StatusId == StatusEnum.Preliminary || this.instruction.StatusId == StatusEnum.Active || this.instruction.StatusId == StatusEnum.SentToSupplier || this.instruction.StatusId == StatusEnum.SentToMultipleSuppliers)

    return !gotAccess
  }

  isEditPRU(): boolean {
    let gotAccess: boolean =(this.instruction.StatusId == StatusEnum.Scrapped||this.instruction.StatusId == StatusEnum.SentToSupplier||this.instruction.StatusId == StatusEnum.SentToMultipleSuppliers);
    return gotAccess;
  }

  isStatusScrapped():boolean{
    let gotAccess: boolean =(this.instruction.StatusId == StatusEnum.Scrapped)||(this.user.IsPartSupplierUser);
    return gotAccess;
  }

  isSupplierWithNoSuppNo(): boolean {
    return this.user.IsPartSupplierUser
      && (this.user.SupplierNumber == null || this.user.SupplierNumber == "0");
  }



  // ----------------------------------------------------------
    // Fetch list data
    // ----------------------------------------------------------

    loadSupplierList() {
      this.showSpinner = true;
      this.showMailingListSpinner = true;
      clearInterval(this.typeDelayTimer);
      this.errHandler.emitErrorObject(null);
      this.supplierService.searchSupplier(this.searchSupplierText)
          .subscribe(returnObject => this.loadSupplierListResponse(returnObject));
  }

  loadSupplierListResponse(returnObject: IReturnObject) {
      if (returnObject.ErrorType != ErrorTypeEnum.NoError)
          this.errHandler.emitError(returnObject.ErrorMsg, 'SupplierContactComponent.loadSupplierListResponse', returnObject.ErrorType);
      else
          this.supplierList = returnObject.DataList;

      this.showMailingListSpinner = false;
  }

    // ----------------------------------------------------------
    // Actions
    // ----------------------------------------------------------
    selectSupplier(supplier: SupplierListBE) {
      let selectedSupplierInfo = new SupplierInfoBE(supplier.Id, supplier.Supplier, supplier.IsActive)


      if(this.instruction.SupplierInfo.findIndex(x=>x.SupplierId===selectedSupplierInfo.SupplierId)<0)
      {
        this.searchSupplierText = "";
        this.instruction.SupplierInfo.unshift(selectedSupplierInfo);
        this.isDuplicate=false;
        this.setDirty();
      clearInterval(this.supplierSearchListDelayTimer);
      this.showSpinner = false;
      }
  }

  doSend() {
      this.supplierMassMailService.sendMassMail(this.mailingList)
          .subscribe(returnObject => this.getSupplierContactResponse(returnObject));
  }

  sendResponse(returnObject: IReturnObject) {
      if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
          this.errHandler.emitError(returnObject.ErrorMsg, 'SupplierContactComponent.actionResponse', returnObject.ErrorType);

      } else {
          this.instruction.SupplierInfo = returnObject.DataList[0];
          this.isDirty = false;
          this.info("Supplier updated: " +  this.instruction.SupplierInfo[0].SupplierId + " - " + this.instruction.SupplierInfo[0].SupplierName);
      }
      this.showSpinner = false;
  }

  getSupplierContact(supplierId: number) {
      this.showSpinner = true;
      clearInterval(this.typeDelayTimer);
      this.errHandler.emitErrorObject(null);
      this.supplierContactService.getContacts(supplierId)
          .subscribe(returnObject => this.getSupplierContactResponse(returnObject));
  }

  getSupplierContactResponse(returnObject: IReturnObject) {
      if (returnObject.ErrorType != ErrorTypeEnum.NoError)
          this.errHandler.emitError(returnObject.ErrorMsg, 'SupplierContactComponent.getSupplierContactResponse', returnObject.ErrorType);
      if (returnObject.DataList.length > 0) {
         // this.supplierInfo = returnObject.DataList[0];
          this.showSpinner = false;
      }

      else {
          this.showSpinner = false;
      }
      this.isFocusSet = false;
      this.isFocusSet = this.setFocus.to("contactName", this.isFocusSet);
  }

  infoSupplier(message: string): void {
      this.errHandler.emitError(message, '', ErrorTypeEnum.Info);
  }

    // ----------------------------------------------------------
    // Search suppliers
    // ----------------------------------------------------------
    searchSuppTextChanged() {
      var that = this; // needed to preserve scope reference to this within setinterval function

      if (that.searchSupplierText.length >= 2) {
          that.viewSupplierList = true;
          //this.searchSupplierText= "" ;
          // If this.typeDelayTimer is not nulll then the
          // user typed somthing new within time limit so reset timer
          if (that.typeDelayTimer != null)
              clearInterval(that.typeDelayTimer);
          that.typeDelayTimer = setInterval(function () {
              that.loadSupplierList();
          }, that.searchKeyStrokeDelay);
      }
      else {
          that.viewSupplierList = false;
          clearInterval(this.typeDelayTimer);


      }
  }

  startSupplierSearchListWithDelay() {
      var that = this;

      if (!that.viewSupplierList) {
          clearInterval(this.supplierSearchListDelayTimer);
          return;
      }

      if (that.supplierSearchListDelayTimer != null)
          clearInterval(that.supplierSearchListDelayTimer);

      that.supplierSearchListDelayTimer = setInterval(function () {
          that.finalizeHideSupplierSearchListWithDelay();
      }, that.searchListDelayTimerDelay);
  }

  finalizeHideSupplierSearchListWithDelay() {
      this.viewSupplierList = false;
      clearInterval(this.supplierSearchListDelayTimer);
  }

  hideSupplierSearchListWithDelay() {
      clearInterval(this.supplierSearchListDelayTimer);
      this.startSupplierSearchListWithDelay();

  }

  showSupplierSearchList() {
      if (this.searchSupplierText.length >= 2) {
          clearInterval(this.supplierSearchListDelayTimer);
          this.viewSupplierList = true;
      }
  }
  //  colorchange :boolean=false;
  // maximumlengthdescription()
  // {
  //   if(this.instruction.Description.length>=50)
  //   {
  //           this.colorchange=true;
  //   }
  //      else{
  //       this.colorchange=false;
  //      }
  // }

  isAtLeasOneSupplier(): boolean {
    if(this.instruction.SupplierInfo != null && this.instruction.SupplierInfo.length > 0&&this.selectSupplier.length>0)
      return true;
    return false;
  }

  onDeleteSupplier(supplier: number) {
    this.errHandler.emitErrorObject(null);
    this.dialogAction = "deletesupplier";
    //this.dialogAppliesToId = this.instruction.SupplierInfo[0].SupplierId;

    //Here we actually pass the position of supplier and not the actual supplier ID
    this.dialogAppliesToId = this.instruction.SupplierInfo.findIndex(x=>x.SupplierId===supplier);
    this.dialogAppliesTo = 'supplier';
    this.dialogBtnType = "danger";
    this.currentDlg = this.modalService.open(this.cdlg, { size: 'sm' })
  }

  toggleOpenClosePanels() {
    if (jQuery('.panel-collapse.out').length > 0) {
      jQuery('#toggleOpenClosePanelsInputText').text(" Close all panels");
      jQuery('.collapsed').attr("aria-expanded", "true");
      jQuery('.panel-collapse').removeClass("out");
      jQuery('.panel-collapse').addClass("in");
    }
    else {
      jQuery('#toggleOpenClosePanelsInputText').text(" Open all panels");
      jQuery('.collapsed').attr("aria-expanded", "false");
      jQuery('.panel-collapse').removeClass("in");
      jQuery('.panel-collapse').addClass("out");
    }
  }


}



// WEBPACK FOOTER //
// C:/Users/SHR6M3/Development/PackITWebGui/src/app/sequence-instruction/sequence-instruction.component.ts